function getColor(color) {
	if (color === "yellow") {
		return "#f2ee84";
	} else if (color === "purple") {
		return "#9b61c1";
	} else if (color === "green") {
		return "#a0d080";
	} else if (color === "blue") {
		return "#90b9e2";
	} else if (color === "navy") {
		return "#3f3f92";
	} else if (color === "synthetic") {
		return "#ff0000ff";
	} else { 
		return "#9e9e9e";
	}
}

export { getColor };